<template>
  <div>
    <app-gridview
      v-bind:parentData="{
        tabHeaders: this.dataHeader,
        tabItems: this.dataItems,
        pageTitle: this.pageTitle,
        search: this.search,
      }"
      v-on:EditItem="editItemHandler($event)"
      v-on:DeleteItem="deleteItemHandler($event)"
      v-on:NewPressed="newRecordHandler"
    ></app-gridview>
  </div>
</template>
<script>
import moment from 'moment';

import GridView from "../../../components/common/GridView";

export default {
  components: {
    "app-gridview": GridView,
  },

  data() {
    return {
      pageTitle: this.$t('ircasemaintenance.dimaintenancelist'),
      dataHeader: [
        { text: this.$t('columns.actions'), value: "action", sortable: false, width: "50px" },
        { text: this.$t('ircasemaintenance.caseid'), value: "caseid", width: "100px" },
        { text: this.$t('ircasemaintenance.incidentdate'), value: "incidentdate", width: "160px" },
        { text: this.$t('ircasemaintenance.incidentshortdesc'), value: "shortdesc", width: "200px" },
        { text: this.$t('columns.staffname'), value: "psnname", width: "200px" },
        { text: this.$t('ircasemaintenance.sessiondesc'), value: "sessiondesc", width: "200px" },
        { text: this.$t('ircasemaintenance.didate'), value: "didate", width: "160px" },
        { text: this.$t('ircasemaintenance.ditime'), value: "ditime", width: "160px" },
        { text: this.$t('ircasemaintenance.divenue'), value: "irdomesticvenuecode", width: "200px" },
       
      ],
      dataItems: [],
      loading: false,
      errMsg: "",
      search: this.$route.params.search,
    };
  },

  methods: {
    getDomesticInquiryHandler() {
      const vm = this;

      this.loading = !this.loading;

      this.$store.dispatch('get', {url: "/irdomesticinquiry/all"})
        .then(function (res) {
          vm.dataItems = res.data.rec;
          
          for (let i = 0; i < vm.dataItems.length; i++) {
              if (vm.dataItems[i].incidentdate) {
                  vm.dataItems[i].incidentdate = moment(vm.dataItems[i].incidentdate).format('YYYY-MM-DD');
                }

              if (vm.dataItems[i].didate) {
                  vm.dataItems[i].didate = moment(vm.dataItems[i].didate).format('YYYY-MM-DD');
                }
          }

          vm.loading = !vm.loading;

        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    editItemHandler(item) {
      this.$router.push({ name: "domesticinquiryedit", params: { id: item.id, search: item.search } });
    },

    newRecordHandler() {
      this.$router.push({ name: "domesticinquirynew" });
    },
  },

  mounted() {
    this.getDomesticInquiryHandler();
  },
};
</script>